import '../../node_modules/configurable-date-input-polyfill/configurable-date-input-polyfill.dist.js';
import FormField from './field.js';

export default class DatePicker extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.input = this.inputs[0].el;
        this.min = this.input.dataset['minOffset'];
        this.max = this.input.dataset['maxOffset'];
        this.limit();
    }

    limit(){
        if(this.min){ this.input.min = this.date(Number(this.min)); }
        if(this.max){ this.input.max = this.date(Number(this.max)); }
    }

    date(offset) {
        const d = new Date();
        d.setDate(new Date().getDate() + offset)
        return d.toISOString().split('T')[0];
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_date_picker');
    }
}